export default __webpack_public_path__ + "static/media/bitOrig.13fa5fa7.jpg";